import { FC, useState, useContext, useEffect } from "react";
import Header from "../SubComponents/Header";
import {
  Typography,
  Grid,
  Container,
  Box,
  useMediaQuery,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import AuthImage from "../SubComponents/AuthImage";
import imageauth from "../../assets/images/authbanner.png";
import useStyles from "../Styles/AuthStyles";
import ExpireLink from "../../assets/images/ExpireLinkIcon.svg";
import VerificationInput from "react-verification-input";
import { Formik, Form } from "formik";
import ButtonSubmit from "../FormsUI/Button";
import { useHistory } from "react-router-dom";
import AuthContext from "../../store/Auth/AuthContext";

const VerificationCode: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const [codeValue, setcodeValue] = useState("");
  const [error, setError] = useState(false);
  const history = useHistory();
  const { isAuth, verify2FA } = useContext<any>(AuthContext);
  const twoFaToken = localStorage.getItem("twoFaToken");

  const [loading, setLoading] = useState<boolean>(false);

  if (!twoFaToken) {
    history.push("/login");
  }
  if (isAuth) {
    history.push("/deals");
  }
  function setcodeValues(val: any) {
    if (val.length === 6) {
      setcodeValue(val);
    } else {
      setError(false);
    }
  }

  useEffect(() => {
    if (codeValue.length === 6) {
      setLoading(true);
      verify2FA(codeValue)
      .then((response: any) => {
        // Do nothing
      })
      .catch((error:any) => {
        setcodeValue("")
        setLoading(false)
      })
    }
  }, [codeValue])

  useEffect(() => {
    return () => {
      setLoading(false);
    }
  }, [])

  const Expire = () => {
    return (
      <img src={ExpireLink} className="img-fluid  imageAlign" alt="Gains" />
    );
  };

  return (
    <Box className={classes.authpages} component="section">
      <Header authPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            <Grid className="borderleft" item md={5} sm={12}>
              <AuthImage image={imageauth} />
            </Grid>
            <Grid className="borderleft  borderRight" item md={7} sm={12}>
              <Box
                className="validateEmailTextBox"
                pl={isActive ? 0 : 7}
                pr={isActive ? 0 : 7}
              >
                <Typography variant="h2" color="primary">
                  2FA
                </Typography>

                <Typography variant="body1">
                  Enter 2FA code from your authenticator app to Sign In.
                </Typography>

                <Formik
                  initialValues={{}}
                  onSubmit={(values) => {
                    if (codeValue.length === 6) {
                      verify2FA(codeValue);
                      setError(false);
                    } else {
                      setError(true);
                    }
                  }}
                >
                  <Form>
                    <Box mt={isActive ? 2 : 3} className="pt-0">
                      <Grid
                        container
                        alignItems="center"
                        spacing={isActive ? 3 : 2}
                      >
                        <Grid item lg={8} md={10} sm={8} xs={12}>
                          <Box mb={isActive ? 1 : 0}>
                            <VerificationInput
                              placeholder=""
                              autoFocus={true}
                              validChars="0-9"
                              onChange={(e) => setcodeValues(e)}
                              classNames={{
                                container: "container",
                                character: "character",
                                characterInactive: "characterInactive",
                              }}
                            />
                          </Box>
                          {error && (
                            <Typography
                              variant="subtitle1"
                              className="error mt-12"
                            >
                              Please enter 6 digits code
                            </Typography>
                          )}
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box
                            display="flex"
                            alignItems="center"
                            mb={isActive ? 1 : 3}
                          >
                            <Tooltip title="Recover sign-in 2FA Enter your account details. We’ll send you an email with a bypass code, so you can sign in without 2FA. You can also bypass sign-in 2FA with a Master Key." enterTouchDelay={0}>
                              <span>
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                  component="span"
                                >
                                  Help
                                  {" "}
                                </Typography>
                                <Expire />
                              </span>
                            </Tooltip>
                          </Box>
                        </Grid>
                        <Grid item lg={5} md={12} sm={12} xs={12}>
                          <ButtonSubmit 
                            disabled={codeValue.length < 6}
                            endIcon={ loading && <CircularProgress size={12} />}
                          >
                            Sign In
                          </ButtonSubmit>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default VerificationCode;
